

























import {
  computed,
  defineComponent,
  useContext,
  watch
} from '@nuxtjs/composition-api';

import { useUiState } from '~/composables/useUiState';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';

export default defineComponent({
  name: 'CategoryCollectionSidebar',
  components: {
    VaimoSidebar: () => import('organisms/VaimoSidebar.vue'),
    VaimoProducts: () => import('organisms/VaimoProducts.vue')
  },
  props: {
    productsSkus: {
      required: true,
      type: Array
    },
    title: {
      required: true,
      type: String
    }
  },
  setup(props) {
    const { isCollectionSidebarOpen, toggleCollectionSidebar } = useUiState();
    const { app } = useContext();
    const categoryStore = useCategoryStore();

    watch(
      () => isCollectionSidebarOpen.value,
      (newValue) => {
        categoryStore.isCollectionSidebarOpen = newValue;
      }
    );

    const getTitle = computed(() => {
      return app.i18n.t('The complete {category_name} collection', {
        category_name: props.title
      });
    });

    return {
      getTitle,
      isCollectionSidebarOpen,
      toggleCollectionSidebar
    };
  }
});
